import axios from "axios"
import { ActionType, BACKEND_URL } from "../constants"
import { IAction, IErrorAction, IPayloadAction, IUser } from "../types";
import { getCurrentTabDetails } from "./currentTabData";

export async function checkIfLoggedIn(dispatch: Function): Promise<void> {
    try {
        dispatch({type: ActionType.LOADING});
        const response = await axios.post(BACKEND_URL + "/auth/isloggedin");
        if (response.data.loggedin) {
            const action: IPayloadAction = {
                type: ActionType.LOGIN,
                payload: {
                    url: "",
                    title: ""
                }
            }

            dispatch(action);
        }

        throw new Error("Something went wrong");

    } catch (err) {
        dispatch({type: ActionType.NOT_LOADING});
    }

    return;
}

export async function logout(dispatch: Function): Promise<void> {
    try {
        await axios.post(BACKEND_URL+"/auth/logout");
        const action: IAction = {
            type: ActionType.LOGOUT,
            payload: {
                isLoggedIn: false
            }
        }

        dispatch(action);

    } catch(err) {

    }
}

export async function signUpUser(payload: IUser, dispatch: Function): Promise<void> {
    try {
        const { name, email } = payload;
        const response = await axios.post(BACKEND_URL + "/auth/signup", { name, email });
        if (!response.data.error) {
            const action: IPayloadAction = {
                type: ActionType.VERIFY_OTP,
                payload: {
                    url: "",
                    title: ""
                }
            }
            dispatch(action);
        }
        return;
    } catch (err) {
        return;
    }
}

export async function signInUser(email: string, dispatch: Function): Promise<boolean> {
    try {
        const response = await axios.post(BACKEND_URL + "/auth/signin", { email });
        if (!response.data.error) {
            const action: IPayloadAction = {
                type: ActionType.VERIFY_OTP,
                payload: {
                    url: "",
                    title: ""
                }
            }

            dispatch(action);
            return true;
        }

        const action: IErrorAction = {
            type: ActionType.ERROR,
            error: {
                status: true,
                message: response.data.message
            }
        };

        dispatch(action);
        return false;

    } catch (err: any) {
        
        return false;
    }
}

export async function verifyUserOtp(otp: string, dispatch: Function): Promise<boolean> {
    try {
        const response = await axios.post(BACKEND_URL + "/auth/verifyotp", { otp });
        if (!response.data.error) {
            const action: IPayloadAction = {
                type: ActionType.LOGIN,
                payload: {
                    url: "",
                    title: ""
                }
            }
            dispatch(action);
            await getCurrentTabDetails(dispatch);
            return true;
        }
        return false;
    }
    catch (err) {
        return false;
    }
}

export const validateEmail = (email: string): RegExpMatchArray | null => {
    const resp =  String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );

    return resp;
};